export const routes = (prefix = `finance-dashboard`) => [
    {
        path: `/${prefix}/supplierpayment/print/:remittanceNo`,
        name: `${prefix}.paymentSlip.print`,
        component: () => import('./prints/payment-slip-print.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.bill-payments.create`,
                PageDescription: "Finance: Bill Payment (Supplier and Consultants)",
            },
        },
    },
];
